import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider} from 'react-router-dom'
import Header from './Pages/Header/Header';
import Main from './Pages/Main/Main';
import Footer from './Pages/Footer/Footer';
import Contacts from './Pages/Contacts/Contacts';
import About from './Pages/About/About';
import CoursePage from './Pages/Courses/CoursePage';
import Policy from './Pages/Policy/Policy';
import Oferta from './Pages/Oferta/Oferta'
import data from './data.json';
import ErrorPage from './Pages/Error/ErrorPage';
import ContactPage from './Pages/Contacts/ContactPage';
import contactData from './Pages/Contacts/contactData.json'


const Root = () => {
  return(
    <div className='container'>
      <Header />
      <div className='main'>
      <Outlet />     
      </div>
      
      <Footer />
    </div>
    
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<Root />} errorElement={<ErrorPage /> }>
        <Route index element={<Main />} />
        <Route path='/contacts' element={<Contacts />} />
        <Route path='/contacts/:name' element={<ContactPage />} loader={contactLoader} />
        <Route path='/about' element={<About />} />
        <Route path='/courses/:name' element={<CoursePage />} loader={courseLoader} />
        <Route path='/policy' element={<Policy />} />
        <Route path='/oferta' element={<Oferta /> } />
      
    </Route>
  )
)

function courseLoader({params}){
  const course = data.find((el) =>  el.path === params.name )
  console.log(course)
  return course
}

function contactLoader({params}){
  const data = contactData.find( el => el.path === params.name)
  return data
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
